module.exports = __webpack_public_path__ + "logoVertical.png?02c2cc95d63a33c50803312a3c8410f1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoVertical.png
// module id = 2084
// module chunks = 2